const data = `
<div style="background:white;" class="px-4 py-4">
<div class='bg-danger'>
<img src="/images/creatives/blog-content-1.png" class="img-fluid w-100" />
</div>



<section class="newspaper-section my-5 mx-lg-5">
  <div class="container">

    <h1 class="news-title">
      Schroeder Ambulatory Centre aims to reduce backlogs
    </h1>

    <p class="author">
      BY JERRY ZEIDENBERG
    </p>

    <div class="news-columns">

      <!-- Column 1 -->
      <div class="column">
        <p>
          <span class="dropcap">R</span>
          ICHMOND HILL, ONT. — The Schroeder Ambulatory Centre (SAC), a charitable non-profit facility in Richmond
Hill, just north of Toronto, has been outfitted
with operating rooms, CT and MRI scanners,
and a host of other equipment and capabilities. The $300 million facility has begun offering services while awaiting final approvals
from Accreditation Canada for diagnostic
imaging and hip and knee surgical programs
        </p>

        <p>
          Eventually, it hopes to do even more –
functioning as a comprehensive, not-forprofit ambulatory health centre.
        </p>

        <p>
         But as a private medical facility, the first
question people ask is, ‘aren’t you going to be
moving surgeons, radiologists, nurses and
technologists away from resource-starved,
traditional hospitals and into your clinic?’
        </p>

         <p>
          In response, chief medical officer Dr. Fabio
Varlese told Canadian Healthcare Technology
that he and his colleagues have been sensitive
to this issue for the four years the Schroeder
Ambulatory Centre has been in the planning
and construction stages.
        </p>

      </div>

      <!-- Column 2 -->
      <div class="column">

       <p> He said the key idea
is to add capacity to the Ontario healthcare
system, and not to diminish it.</p>
        <div class="quote-box">
          <div class="quote-line"></div>

          <h3 style="font-size:20px">
            The key idea is to add capacity to Ontario's healthcare system,
            not to diminish it.
          </h3>
        </div>

           <img src="/images/creatives/fabio-img.jpg" class="img-fluid"/>
<p class="author" style="border-bottom:1px solid black;">
      Dr. Fabio Varlese
    </p>
        <p> “It was crucial for us to find a way to not simply shift capacity from the hospital system to facilities like ours,” he said.</p>

        <p>So, when it comes to surgeries, he noted
that most Ontario surgeons are only in the
OR one or </p>


      

       
      </div>

      <!-- Column 3 -->
      <div class="column">

      <p>two days a week. SAC will enable
them to do surgeries on other days, which
will increase surgical capacity in the region.
Dr. Varlese said they won’t be taking these
surgeons away from their regular hospital
duties but will give them the resources to do
more operations – to the benefit of patients.
As he puts it, “physicians will continue to
deliver most of their care from their home
hospitals.”</p>

       <p>
          In July 2025, the Ontario government announced it will invest $155 million over two
years to add 57 new community surgical
and diagnostic centres licensed to deliver
MRI and CT scans, and gastrointestinal (GI)
endoscopy services across the province. The
expansion will help 1.2 million people access publicly funded procedures faster, the
Doug Ford government said.
        </p>

        <p>
          For its part, the Schroeder Ambulatory
Centre is receiving $14 million to provide
MRI and CT scans, as well as GI endoscopy
procedures to over 115,000 patients over
two years, significantly reducing wait times
in the region.
Adding private medical centres to the mix
        </p>


      

      

      </div>

    </div>
  </div>
</section>

<div class="mx-lg-5">
<img src="/images/creatives/blog-content-2.png" class="img-fluid w-100 d-lg-block d-none" />
</div>

<div class="mx-lg-5">
<img src="/images/creatives/blog-content-2-mob.png" class="img-fluid w-100 d-lg-none d-block" />
</div>

</div>

<style id="p3c71q">
.newspaper-section{
    background:#ece7e7;
    padding:60px 20px;
    font-family:Georgia, serif!important;
}

.container{
    max-width:1400px;
    margin:auto;
}

.news-title{
    font-size:44px;
    line-height:1.05;
    font-weight:500;
    color:#2b2525;
    margin-bottom:24px;
    letter-spacing:-1px;
        font-family:Georgia, serif!important;
}

.author{
    font-family:Arial, sans-serif;
    font-size:14px;
    font-weight:700;
    letter-spacing:2px;
    margin-bottom:40px;
    color:#2f2f2f;
}

.news-columns{
    display:grid;
    grid-template-columns:repeat(3,1fr);
    gap:40px;
}

.column{
    font-size:16px;
    line-height:1.7;
    color:#373737;
    font-weight:400;
}

.column p{
    margin-bottom:14px;
}

.dropcap{
    float:left;
    font-size:50px;
    line-height:.8;
    padding-right:12px;
    color:#000;
}

.quote-box{
    display:flex;
    gap:18px;
    align-items:flex-start;
    margin:20px 0;
}

.quote-line{
    width:8px;
    min-height:95px;
    background:#b3202a;
    border-radius:100px;
}

.quote-box h3{
    font-size:28px;
    line-height:1.25;
    font-weight:700;
    margin:0;
    color:#2b2b2b;
}

.continued{
    text-align:right;
    font-size:14px;
    font-family:Arial, sans-serif;
    letter-spacing:2px;
    font-weight:700;
}

/* Tablet */
@media(max-width:1200px){

    .news-title{
        font-size:48px;
    }

    .column{
        font-size:22px;
    }

    .quote-box h3{
        font-size:34px;
    }
}

/* Mobile */
@media(max-width:768px){

    .newspaper-section{
        padding:40px 18px;
    }

    .news-title{
        font-size:34px;
    }

    .news-columns{
        grid-template-columns:1fr;
        gap:20px;
    }

    .column{
        font-size:18px;
        line-height:1.8;
    }

    .dropcap{
        font-size:72px;
    }

    .quote-box{
        margin:35px 0;
    }

    .quote-line{
        min-height:110px;
    }

    .quote-box h3{
        font-size:26px;
    }
}
</style>
`;
		export default data